import { z } from 'zod'

export const AnimalGenders = {
  MALE: 'male',
  FEMALE: 'female',
} as const
export type AnimalGender = typeof AnimalGenders[keyof typeof AnimalGenders]

export const AnimalGenderSchema = z.nativeEnum(AnimalGenders)

export function PaginatedListOf<T>(schema: z.ZodType<T>) {
  return z.object({
    results: schema.array(),
    count: z.number(),
    limit: z.number(),
    offset: z.number(),
  })
}
